<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import LaisGamificationSurface from 'dashboard/components-next/LaisGamificationSurface.vue';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import { useMapGetter } from 'dashboard/composables/store';
import SalesTransactionDetailContent from '../components/SalesTransactionDetailContent.vue';
import { useSalesTransactionDetail } from '../composables/useSalesTransactionDetail';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const transactionId = computed(() =>
  route.params.salesTransactionId?.toString()
);
const detail = useSalesTransactionDetail({ id: transactionId, t });

const backToFinance = () =>
  router.push({
    name: 'operacao_imobiliaria_financeiro',
    params: { accountId: route.params.accountId },
  });
</script>

<template>
  <LaisGamificationSurface
    :user-id="currentUser?.id"
    show-rail
    class="min-h-full bg-lais-bg-soft"
  >
    <LaisHeader
      :title="t('REAL_ESTATE_FINANCE.SALE_DETAIL.TITLE')"
      :subtitle="t('REAL_ESTATE_FINANCE.SALE_DETAIL.SUBTITLE')"
      :breadcrumb="[
        { label: t('REAL_ESTATE_FINANCE.TITLE') },
        { label: t('REAL_ESTATE_FINANCE.SALE_DETAIL.TITLE') },
      ]"
      show-back
      :back-label="t('REAL_ESTATE_FINANCE.SALE_DETAIL.BACK')"
      @back="backToFinance"
    />
    <main class="mx-auto w-full max-w-[1600px] px-4 pb-8 sm:px-6 lg:px-10">
      <div
        v-if="detail.loading.value"
        class="rounded-lais border border-lais-border-soft bg-white p-8 text-center text-sm text-lais-text-muted"
      >
        {{ t('REAL_ESTATE_FINANCE.SALE_DETAIL.LOADING') }}
      </div>
      <div
        v-else-if="detail.error.value"
        class="rounded-lais border border-lais-danger/30 bg-white p-8 text-center text-sm text-lais-danger"
      >
        {{ detail.error.value }}
      </div>
      <SalesTransactionDetailContent
        v-else-if="detail.transaction.value"
        :show-summary="false"
        :transaction="detail.transaction.value"
      />
      <div
        v-else
        class="rounded-lais border border-dashed border-lais-border bg-white p-8 text-center text-sm text-lais-text-muted"
      >
        {{ t('REAL_ESTATE_FINANCE.SALE_DETAIL.EMPTY') }}
      </div>
    </main>
  </LaisGamificationSurface>
</template>
